<script lang="ts">
import { defineComponent } from '@vue/composition-api';

interface IProps {
    isOpen: boolean;
    hasCloseButton: boolean;
    title: string;
    width?: number | string;
    shouldCloseOnClickOutside: boolean;
}

export default defineComponent<IProps>({
    name: 'AppDialog',
    props: {
        isOpen: Boolean,
        title: String,
        width: [Number, String],
        shouldCloseOnClickOutside: {
            type: Boolean,
            default: true,
        },
        hasCloseButton: {
            type: Boolean,
            default: true,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        contentClass: {
            type: String,
            default: '',
        },
    },

    // eslint-disable-next-line
    setup(props, ctx) {
        const close = () => {
            ctx.emit('close');
        };

        const onClickOnOutside = () => {
            if (props.shouldCloseOnClickOutside) {
                close();
            }
        };

        return {
            close,
            onClickOnOutside,
        };
    },
});
</script>

<template>
  <v-dialog
    :width="width ? width : 1084"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    persistent
    :value="isOpen"
    class="no-click-outside"
    :content-class="`no-click-outside ${contentClass}`"
    :scrollable="scrollable"
    :overlay-opacity="0"
    @keydown.esc="close"
    @click:outside="onClickOnOutside"
  >
    <v-card class="pb-2">
      <slot name="top" />

      <v-card-title class="headline d-flex flex-nowrap align-start">
        <slot name="title">
          {{ title }}
        </slot>
        <v-spacer />
        <slot name="headerRight" />
        <v-btn v-if="hasCloseButton" icon @click="close">
          <v-icon>$delete</v-icon>
        </v-btn>
      </v-card-title>
      <template v-if="isOpen">
        <slot />
      </template>
    </v-card>
  </v-dialog>
</template>
